import React from 'react';
import appLabels from '../../utils/appLabels';
import ErrorIcon from '../Icons/ErrorIcon';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';

const paymentErrorMessageContainereStyle = css`
  display: flex;
  align-items: self-start;
  border-radius: 8px;
  border: 1px solid #fbb5b5;
  background: #faf9f8;
  padding: 12px 16px;
  margin-bottom: 24px;
  gap: 10px;
`;

const paymentErrorMessagTextStyle = css`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
`;

const updatePaymentTextStyle = css`
  text-decoration: underline;
  text-decoration-skip-ink: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

const PaymentErrorMessageComponent = ({ className }) => {
  const handleUpdatePaymentClick = () => {
    // Logic to handle the update payment click
    const highlightTab: HTMLElement | null = document.getElementById('tab-2');
    if (highlightTab) {
      highlightTab.click();
    }
  };
  return (
    <div className={`${paymentErrorMessageContainereStyle} ${className}`}>
      <ErrorIcon />
      <div className={paymentErrorMessagTextStyle}>
        {appLabels.UserWithActiveOrders.paymentErrorMessage}
        <span className={updatePaymentTextStyle} onClick={handleUpdatePaymentClick}>
          {appLabels.UserWithActiveOrders.updatePaymentLinkText}
        </span>
      </div>
    </div>
  );
};

PaymentErrorMessageComponent.propTypes = {
  className: PropTypes.string,
};

export default PaymentErrorMessageComponent;
